import { RouteMeta, RouteRecordRaw } from 'vue-router';
import { useTranslation, getAllowedLocalesForRouter } from '@hfc/ui-core';
import { carrierRouter } from '@/page/infrastructure/router/carrierRouter';
import { metalPlanRouter } from '@/page/infrastructure/router/metalPlanRouter';
import HomeContent from '@/page/infrastructure/views/HomeContent.vue';
import FaqContent from '@/page/infrastructure/views/FaqContent.vue';
import EHealth from '@/page/infrastructure/views/EHealth.vue';
import ContactUs from '@/page/infrastructure/views/ContactUs.vue';
import AboutUs from '@/page/infrastructure/views/AboutUs.vue';
import CoveredCalifornia from '@/page/infrastructure/views/CoveredCalifornia.vue';

const { t } = useTranslation();

export const pageRouter: Array<RouteRecordRaw & { meta: RouteMeta }> = [
  {
    path: '/',
    name: 'home',
    meta: {
      layout: 'HomePage'
    },
    component: HomeContent,
  },
  {
    path: '/faq',
    name: 'FAQ',
    meta: {
      layout: 'HomePage',
      title: 'Covered California FAQ - Frequently Asked Questions',
      description: 'Find FAQs below about Healthcare Reform and the Affordable Care Act. View questions and answers related to California Health Insurance, Covered',
    },
    component: FaqContent
  },
  {
    path: '/contact-us',
    name: 'ContactUs',
    meta: {
      layout: 'DefaultPage',
      theme: 'light',
      title: 'Contact Information Health for California',
      description: 'Do you have a question and need to contact us? Get contact info for enrollment, quotes, Covered CA, Medi-Cal, Health Plans and more all on this page.',
    },
    component: ContactUs
  },
  {
    path: '/about-us',
    name: 'AboutUs',
    meta: {
      layout: 'DefaultPage',
      theme: 'light',
      title: 'About Us: Health for California',
      description: 'Our vision is to help Californians get quality, affordable health insurance coverage. Learn more about our licensed agents and how they\'ll help you.',
    },
    component: AboutUs
  },
  {
    path: '/health-app-partnership',
    name: 'eHealthLead',
    meta: {
      layout: 'DefaultPage',
      title: 'Options Outside of California',
      description: 'We simplify what is normally a difficult process! Finding the right health plan outside California can be stressful and time-consuming. Let us help you find the best health insurance plan for you!',
      theme: 'light',
      hideGetQuoteBanner: true,
      breadcrumbs: [
        {
          label: 'California Health Insurance',
          href: '/'
        },
        {
          label: 'Options Outside of California',
          href: '/health-app-partnership'
        }
      ],

    },
    component: EHealth
  },
  {
    path: `/${getAllowedLocalesForRouter()}/covered-california`,
    name: 'CoveredCalifornia',
    meta: {
      layout: 'DefaultPage',
      theme: 'light',
      title: t('routes.coveredCalifornia.title'),
      description: t('routes.coveredCalifornia.description'),
      i18n: {
        useLocale: true
      }
    },
    component: CoveredCalifornia
  },
  ...carrierRouter.getRoutes(),
  ...metalPlanRouter.getRoutes(),
];
